module.exports = __webpack_public_path__ + "static/media/priority_icon.1eb75a8d.svg";